import React from 'react';
import styles from 'styles/layout/TheTeamSection.module.sass';
// Core Team
import KofiImg from 'assets/images/png/Kofi.png';
import AbigailImg from 'assets/images/png/Abigail.png';
import DeborahImg from 'assets/images/png/Deborah.png';
import EricImg from 'assets/images/jpg/Eric.jpg';
// Advisors
import RochelleImg from 'assets/images/jpg/Rochelle.jpg';
import DesmondImg from 'assets/images/jpg/Desmond.jpeg';
import RogerImg from 'assets/images/jpg/Roger.jpg';

// Core Team and Advisor Data
const coreteam = [
  { name: 'Abigail Aidoo', role: 'Co-CEO and Chief Marketing Officer', image: AbigailImg },
  { name: 'Debbie Oppong-Asumang', role: 'Chief Operations Officer', image: DeborahImg },
  { name: 'Eric Mwaura', role: 'Chief Technology Officer', image: EricImg },
  { name: 'Kofi Oppong-Asumang', role: 'Co-CEO and Chief Finance Officer', image: KofiImg },
];

const advisors = [
  { name: 'Desmond Israel', role: 'Data Privacy, Security & Legal', image: DesmondImg },
  { name: 'Rochelle Grayson', role: 'Strategy, Branding & Positioning', image: RochelleImg },
  { name: 'Roger Bailey', role: 'Data Analytics, AI & ML', image: RogerImg },
];

/**
 * ProfileGrid component renders a grid of team member profiles.
 * 
 * Each profile includes an image, name, and role.
 * 
 * @component
 * 
 * @example
 * // Example usage:
 * <ProfileGrid items={coreteam} />
 * 
 * @param {Object} props - The component props.
 * @param {Array} props.items - An array of objects containing name, role, and image for each team member.
 * @returns {JSX.Element} The rendered ProfileGrid component.
 */
const ProfileGrid: React.FC<{ items: { name: string; role: string; image: string }[] }> = ({ items }) => (
  <div className={styles['profile-grid']}>
    {items.map((person) => (
      <div className={styles['profile-cell']} key={person.name}>
        <img src={person.image} alt={person.name} className={styles['profile-img']} />
        <p className={styles['profile-name']}>{person.name}</p>
        <p className={styles['profile-role']}>{person.role}</p>
      </div>
    ))}
  </div>
);

const TheTeamSection: React.FC = () => (
  <div className={styles['team-page']}>
    {/* Core Team */}
    <section className={styles['the-team-section']}>
      <div className={styles['subsection']}>
        <p className={styles['the-team-label']}>The Team</p>
        <div className={styles['section-header']}>
          <h3 className={styles['coreteam-heading']}>Core Team</h3>
          <p className={styles['coreteam-paragraph']}>
            Our core team provides strategic oversight, and ensures Zerone stays focused on delivering impactful, data-driven solutions.
          </p>
        </div>
        <ProfileGrid items={coreteam} />
      </div>
    </section>

    {/* Advisors */}
    <section className={styles['advisors-section']}>
      <div className={styles['subsection']}>
        <div className={styles['section-header']}>
          <h3 className={styles['advisors-heading']}>Our Advisors</h3>
          <p className={styles['advisors-paragraph']}>
            Our advisors offer expert guidance to help shape Zerone’s growth, ethics, and innovation in the data space.
          </p>
        </div>
        <ProfileGrid items={advisors} />
      </div>
    </section>
  </div>
);

export default TheTeamSection;
